import { h } from 'preact'

import { IconComponentProps } from './index'

export default ({ width = 72, height = 72, customClass='' }: IconComponentProps) => <svg width={width} height={height} viewBox="0 0 72 72" fill="none" class={customClass}>
<path d="M57 33H15C11.6863 33 9 35.6863 9 39V60C9 63.3137 11.6863 66 15 66H57C60.3137 66 63 63.3137 63 60V39C63 35.6863 60.3137 33 57 33Z" stroke="#6B707E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M21 33V21C21 17.0218 22.5804 13.2064 25.3934 10.3934C28.2064 7.58035 32.0218 6 36 6C39.9782 6 43.7936 7.58035 46.6066 10.3934C49.4196 13.2064 51 17.0218 51 21V33" stroke="#6B707E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
